import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "src/app/services/baseQuery";

export const api = createApi({
  baseQuery: baseQuery,
  tagTypes: [],
  endpoints: (build) => ({
    postApiAccountLogin: build.mutation<
      PostApiAccountLoginApiResponse,
      PostApiAccountLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/login`,
        method: "POST",
        body: queryArg,
      }),
    }),
    postApiConvertTusFile: build.mutation<
      void,
      PostApipostApiConvertTusFileApiArg
    >({
      query: (queryArg) => ({
        url: `/files/convert-tus-file`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getApiConvertedFiles: build.query<
      GetApiConvertedFilesApiResponse[],
      string
    >({
      query: (tusFileId) => ({
        url: `/files/converted-files/${tusFileId}`,
        method: "GET",
      }),
    }),
    getApiUploadedFiles: build.query<GetApiUploadedFilesApiResponse[], void>({
      query: () => ({
        url: `/files/uploaded-files`,
        method: "GET",
      }),
    }),
    getChannels: build.query<any[], void>({
      query: () => ({
        url: "/channels",
        method: "GET",
      }),
    }),
    createChannel: build.mutation<void, ICreateChannel>({
      query: (queryArg) => ({
        url: `/channels/create`,
        method: "POST",
        body: queryArg,
      }),
    }),
    getAllVideos: build.query<IVideos, void>({
      query: () => ({
        url: "/videos",
        method: "GET",
      }),
    }),
    getVideoById: build.query<any[], string>({
      query: (id) => ({
        url: `/videos/${id}`,
        method: "GET",
      }),
    }),
    deleteChannel: build.mutation<void, string>({
      query: (id: string) => ({
        url: `/channels/${id}`,
        method: "DELETE",
      }),
    }),
    updateChannel: build.mutation<void, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/channels/${id}`,
        method: "PUT",
        body: data,
      }),
    }),
    uploalFileFromUrl:build.mutation<any , {url:string, title:string  , channelId:string}>({
      query:({url , title , channelId})=>({
        url:'/files/uploadFromUrl',
        method:"POST",
        body:{url,channelId ,title}
      })
    })
  }),
});

export type LoginResponse = {
  token: string;
};

export type PostApiAccountLoginApiResponse = LoginResponse;
export type PostApiAccountLoginApiArg = {
  username: string;
  password: string;
};

export type ConvertVideoResponseType = {
  file_URL: string;
};

export type PostApipostApiConvertTusFileApiArg = {
  tusFileId: string;
  bitrate: string;
  quality: string;
};

export type GetApiConvertedFilesApiResponse = {
  _id: string;
  converted_file_name: string;
  bitrate: string;
  quality: string;
  tus_file_id: string;
  folderName: string;
  file_status: number | string;
  __v: number;
};

export type GetApiUploadedFilesApiResponse = {
  _id: string;
  tus_file_id: string;
  file_size: string;
  file_metadata: string;
  file_status: number | string;
  channelTitle:string | null | undefined; 
  __v: number;
};

export interface ICreateChannel {
  title?: string;
  description?: string;
}

export interface IVideos {
  items: any[];
  limit: number;
  page: number;
}

export const {
  usePostApiAccountLoginMutation,
  useGetApiConvertedFilesQuery,
  usePostApiConvertTusFileMutation,
  useGetApiUploadedFilesQuery,
  useGetChannelsQuery,
  useCreateChannelMutation,
  useGetAllVideosQuery,
  useLazyGetVideoByIdQuery,
  useDeleteChannelMutation,
  useUpdateChannelMutation,
  useUploalFileFromUrlMutation
} = api;
